import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProcessorReport, ProcessorReportsService } from 'src/app/services/processor-reports.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth.service';
import * as moment from 'moment';
import { VendorSelectValues } from 'src/app/packages-module/models/searchPackage';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-vendor-search-breakdown-dialog',
  templateUrl: './vendor-search-breakdown-dialog.component.html',
  styleUrls: ['./vendor-search-breakdown-dialog.component.less']
})
export class VendorSearchBreakdownDialogComponent implements OnInit ,OnDestroy {

  report : ProcessorReport;
  public fromDateTmp: moment.Moment = moment().subtract(1, 'months').set({'hour': 0, 'minute': 0, 'second': 0}).startOf('month').utc();
  public toDateTmp: moment.Moment = moment().subtract(1, 'months').set({'hour': 23, 'minute': 59, 'second': 59}).endOf('month').utc();
  public selectedVendor : number;
  public fromDate: any;
  public toDate: any;
  processing : boolean;
  partyOn : Subject<any> = new Subject<any >();
  constructor(public modalRef: NgbModal, public procRpts : ProcessorReportsService, public auth: AuthService) { }
  ngOnDestroy(): void {
    this.modalRef.dismissAll();
  }

  cancel(){
    this.modalRef.dismissAll();
  }

  download(){
    // var vnd = this.procRpts.searchVendors.find(vndr => {return vndr.vendorId == this.selectedVendor})
    // this.selectedVendor = vnd;
    var vals = {};
    vals['startDate'] = this.fromDate;
    if(this.selectedVendor)
      vals['searchVendor'] = this.selectedVendor;
    if(!this.toDate){
      vals['endDate'] = new Date().toISOString().split('T')[0]
    }else
    vals['endDate'] = this.toDate;
    this.partyOn.next(vals);
  }

  setVendor(id: number){
    // console.warn('setting vendor',vndr);
   
  }
  ngOnInit(): void {
  }

}
